// Utilities to help serialize & deserialize ImmutableJS data structures, which
// are what's used behind the scenes in DraftJS & ReactRTE.

import processIncoming from './incoming.js'
import { serializeMessage, serializeSetting } from './outgoing.js'

export { processIncoming, serializeMessage, serializeSetting }



// WEBPACK FOOTER //
// ./src/services/draft-state/index.js